import {useEffect, useRef} from 'react';
import {useModalData} from '@Components/modal/hooks/useModalData';
import {MODALS_IDS} from '@Components/modal-container';
import {useAiChat} from '@/ai-chat/providers/ai-chat.context';
import {LoadingStates} from '@Utils/loading.util';
import {invalidateModalSession} from '@Components/ai-chat-window/lib/ai-action-loading-modal.library';

export const useResetAnimationActionLoadingStatesOnModalClose = (chatId: string, animationHashedId: string): void => {
  const {actions} = useAiChat();
  const modal = useModalData(MODALS_IDS.AI_ACTION_LOADING_MODAL);
  const wasOpenRef = useRef<boolean>(modal?.isOpen);

  useEffect(() => {
    const isCurrentlyOpen = modal?.isOpen;

    if (wasOpenRef.current && !isCurrentlyOpen) {
      invalidateModalSession();
      actions.updateLoadingStatesForAnimationActions(chatId, animationHashedId, {
        downloadLoadingState: LoadingStates.NOT_LOADED,
        openEditorLoadingState: LoadingStates.NOT_LOADED,
        publishingLoadingState: LoadingStates.NOT_LOADED,
        loadingPublishingOption: null,
      });
    }

    wasOpenRef.current = isCurrentlyOpen;
  }, [modal?.isOpen]);
};
